import {
  updateResourceState,
  createResourceReducer,
  RESOURCE
} from '@unicus/react-ui-kit';
import {
  COLLABORATOR,
  COLLABORATOR_INVITATION_RESEND,
  COLLABORATOR_INVITATION_RESEND_FINISHED,
  COLLABORATOR_CHANGE_INACTIVATE,
  COLLABORATOR_CHANGE_INACTIVATE_FINISHED
} from './collaboratorActions';

const collaboratorReducer = createResourceReducer(
  COLLABORATOR,
  [],
  {
    [COLLABORATOR_INVITATION_RESEND_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loaded: false
      }));
    },

    [COLLABORATOR_CHANGE_INACTIVATE_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loaded: false
      }));
    }
  },
  (state, action) => {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: false
    }));
  }
);

export default collaboratorReducer;
